import * as PlayPauseButton from './PlayPauseButton'
import * as SkipButton from './SkipButton'
import * as Buttons from './Buttons'
import * as Time from './Time'
import * as Slider from './Slider'
import * as Waveform from './Waveform'
import * as TrackDetails from './TrackDetails'
import * as Wrapper from './Wrapper'

export type StyleFn = (
  props: { [key: string]: any },
  state?: { [key: string]: any }
) => React.CSSProperties

export type StylesObj = PlayPauseButton.StylesObj &
  SkipButton.StylesObj &
  Buttons.StylesObj &
  Time.StylesObj &
  Slider.StylesObj &
  Waveform.StylesObj &
  TrackDetails.StylesObj &
  Wrapper.StylesObj

export type Styles = PlayPauseButton.Styles &
  SkipButton.Styles &
  Buttons.Styles &
  Time.Styles &
  Slider.Styles &
  Waveform.Styles &
  TrackDetails.Styles &
  Wrapper.Styles

export type StyleKey = keyof Styles

export const defaultStyles: Styles = {
  ...PlayPauseButton.defaultStyles,
  ...SkipButton.defaultStyles,
  ...Buttons.defaultStyles,
  ...Time.defaultStyles,
  ...Slider.defaultStyles,
  ...Waveform.defaultStyles,
  ...TrackDetails.defaultStyles,
  ...Wrapper.defaultStyles,
}

export {
  PlayPauseButton,
  SkipButton,
  Buttons,
  Time,
  Slider,
  Waveform,
  TrackDetails,
  Wrapper,
}
